import { css } from 'styled-components'

import { defaultTheme as theme } from '../../theme'

export const mobile = (body: any) => css`
  @media (max-width: ${theme.breakpoints.tabletVertical}px) {
    ${body};
  }
`
export const tablet = (body: any) => css`
  @media (max-width: ${theme.breakpoints.tabletHorizontal}px) {
    ${body};
  }
`
